import * as React from "react"
import type { SVGProps } from "react"
const SvgRecPaid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M19.79 9.9q.68 0 1.2.51.51.53.51 1.2v1.72l-.02.21a6 6 0 0 0-1.7-.84v-1.1h-7.71l1.16-4.71-3.73 3.73v8.7h2.57q.14.9.53 1.71H5.2a1.7 1.7 0 0 1-1.2-.5 1.7 1.7 0 0 1-.51-1.21V11.6q0-.7.5-1.2a1.7 1.7 0 0 1 1.21-.51h2.6l5.14-5.1q.32-.32.76-.38t.85.16.6.6q.18.4.08.8l-.96 3.92zm-12 9.43V11.6H5.2v7.72z"
    />
    <path d="M17.57 22.27a.6.6 0 0 0 .39.16q.21 0 .36-.16a.6.6 0 0 0 .16-.4v-.13q.8-.15 1.3-.68.5-.52.5-1.24 0-.78-.42-1.25a3 3 0 0 0-1.33-.78 4 4 0 0 1-1.12-.5q-.24-.2-.24-.44 0-.21.2-.35.2-.15.55-.15.18 0 .36.05t.29.17q.28.22.52.29a.7.7 0 0 0 .44 0 .6.6 0 0 0 .37-.38.5.5 0 0 0-.07-.5 2 2 0 0 0-.59-.54 3 3 0 0 0-.76-.3v-.15a.6.6 0 0 0-.15-.4.5.5 0 0 0-.38-.16.54.54 0 0 0-.55.56v.15q-.81.18-1.2.7t-.38 1.07q0 .7.44 1.17.45.45 1.45.8a3 3 0 0 1 .95.43q.28.23.28.51 0 .26-.24.46t-.68.2q-.22 0-.49-.14a1.4 1.4 0 0 1-.46-.42 1 1 0 0 0-.42-.33.7.7 0 0 0-.48 0 .6.6 0 0 0-.4.34.6.6 0 0 0 0 .5q.22.45.65.8.42.33.98.48v.16q0 .25.17.4" />
  </svg>
)
export default SvgRecPaid
